class BlipPortalDestinations {
    static MESSAGING_HUB_SERVICE = 'MessagingHubService';

    static BLIP_SERVICE = 'BlipService';
}

export default BlipPortalDestinations;
